<template>
    <!--弹窗-->
    <el-dialog width="500px" title="关键词" :visible.sync="visible" :before-close="handleClose" top="5vh" append-to-body>
        <el-form ref="formData" :inline="true" size="mini">
            <el-form-item label="关键词:" class="query-form-item">
                <el-input style="width: 450px;" clearable v-model="keyWord" placeholder="请输入关键词，使用逗号分割" size="mini"></el-input>
            </el-form-item>
        </el-form>

        <el-row style="margin-top:17px;">
            <el-button style="float:right;margin-left:6px;" size="mini" type="danger" plain @click="handleClose()">关 闭
            </el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm(true)">确 定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
    export default {
        data() {
            return {
                keyWord: '',
                visible: false,
            }
        },
        methods: {
            openModal() {
                this.visible = true
            },
            // 保存信息
            submitForm() {
                if (this.keyWord.trim() !== '') {
                    this.handleClose(true, this.keyWord)
                } else {
                    this.$message.info('关键词不能为空')
                }
            },
            // 关闭弹窗
            handleClose(flag = false) {
                let arr = this.keyWord.replaceAll('，', ',').split(',')
                arr = arr.filter(item=>item.trim() !== '')
                arr = arr.map(item=>item.trim())
                const currentDate = this.getYMDString()
                arr = arr.map(item=>{
                    return {keyword: item, date: currentDate}
                })
                this.$emit('close-callback', {flag: flag, keyWord: arr})
                this.keyWord = ''
                this.visible = false
            },
            getYMDString() {
                var now = new Date();
                var year = now.getFullYear();
                var month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的
                var day = now.getDate().toString().padStart(2, '0');
                return year + '-' + month + '-' + day;
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .subTitle {
        font-size: 16px;
        font-weight: 900;
        margin: 20px 0;
    }

    .top1 {
        width: 100%;
        display: flex;
        justify-content: space-between;

        .top1Right {
            display: flex;
            flex-wrap: wrap;
            width: 1200px;

            .itemInfo {
                width: 360px;
                display: flex;
                height: 28px;
                line-height: 28px;

                .itemTitle {
                    font-size: 14px;
                    color: #606266;
                    padding: 0 12px 0 0;
                    font-weight: 900;
                }

                .itemContent {
                    width: 230px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }

    .top3 {
        display: flex;
        justify-content: space-between;
        width: 600px;

        .top3Left {
            width: 100px;
            height: 120px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;

            button {
                margin-top: 10px;
            }
        }

        .top3Right {
            width: 400px;

        }
    }

    .top4 {
        .line1, .line2, .line4, .line3 {
            display: flex;
            justify-content: start;
        }

        .itemInfo {
            width: 25%;
            display: flex;
            height: 28px;
            line-height: 28px;
            margin-bottom: 10px;

            .itemTitle {
                font-size: 14px;
                color: #606266;
                padding: 0 12px 0 0;
                font-weight: 900;
            }

            .itemContent {
                max-width: 230px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .line4 {
            .line4Left, .line4Right {
                width: 50%;
            }

            .itemInfo {
                width: 100%;
            }
        }

    }

    .content {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #cecfd1;
        font-size: 12px;
        color: #000;

        .shu {
            border-right: 1px solid #cecfd1;
        }

        .content-div {
            width: 50%;
            padding: 25px 20px;
        }

        .content-buttom {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #cecfd1;
            padding-bottom: 8px;
            margin-bottom: 10px;
        }

        .content-buttom-txet {
            color: rgb(57, 187, 252);
            cursor: pointer;
        }

        .content-data {
            width: 100%;
            height: 230px;
            overflow: auto;

            .content-list {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 10px 0;

                .cha {
                    cursor: pointer;
                    font-size: 15px;
                    color: rgb(158, 192, 209);
                    margin: 0 10px 0 12px;
                }
            }
        }

        /deep/ .content-data::-webkit-scrollbar {
            width: 3px;
            height: 5px;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-track-piece {
            background-color: #ffff;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
            height: 5px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
            width: 3px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }
    }

    .media-txt {
        font-size: 15px;
        color: #6a6c6f;
        font-weight: 600;
        margin-bottom: 8px;
    }

    /deep/ .el-dialog__body {
        padding: 0px 20px 20px 20px !important;
    }

    /deep/ .el-form-item {
        margin-bottom: 12px !important;
    }
</style>
